import React, { useState } from 'react';
import { Info } from 'lucide-react';

interface TooltipIconProps {
  content: string;
  className?: string;
}

export const TooltipIcon: React.FC<TooltipIconProps> = ({ content, className = '' }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        className={`inline-flex items-center ${className}`}
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
        onFocus={() => setIsVisible(true)}
        onBlur={() => setIsVisible(false)}
      >
        <Info className="w-4 h-4 text-gray-400 hover:text-gray-600 transition-colors" />
      </button>
      
      {isVisible && (
        <div className="absolute z-50 w-64 p-3 mt-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg left-1/2 transform -translate-x-1/2">
          <div className="whitespace-pre-wrap">{content}</div>
          {/* Arrow pointing up */}
          <div className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 bg-gray-900 rotate-45"></div>
        </div>
      )}
    </div>
  );
};
